import React from "react";
import { ArrowDownOutlined } from "@ant-design/icons";

const SortableColumn = ({
  label,
  dataIndex,
  sorter,
  iconSize = 15,
  iconColor = "gray",
}) => {
  return {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {label}
        <div>
          <ArrowDownOutlined style={{ fontSize: iconSize, color: iconColor }} />
        </div>
      </div>
    ),
    dataIndex: dataIndex,
    sorter: sorter || ((a, b) => a[dataIndex]?.localeCompare(b[dataIndex])),
  };
};

export default SortableColumn;

// import React from "react";
// import {
//   ArrowUpOutlined,
//   ArrowDownOutlined,
//   SwapOutlined,
// } from "@ant-design/icons";

// const getDefaultSorter = (dataIndex, dataType) => {
//   return (a, b) => {
//     if (dataType === "number") {
//       return (Number(a[dataIndex]) || 0) - (Number(b[dataIndex]) || 0);
//     }

//     if (dataType === "date") {
//       return new Date(a[dataIndex]) - new Date(b[dataIndex]);
//     }

//     return String(a[dataIndex] || "").localeCompare(String(b[dataIndex] || ""));
//   };
// };

// const SortableColumn = ({
//   label,
//   dataIndex,
//   dataType = "string",
//   sorter,
//   columnKey,
//   sortedInfo,
//   iconSize = 14,
//   iconColor = "gray",
// }) => {
//   const order = sortedInfo?.columnKey === columnKey ? sortedInfo.order : null;

//   const renderIcon = () => {
//     if (!order)
//       return <SwapOutlined style={{ fontSize: iconSize, color: iconColor }} />;

//     if (order === "ascend")
//       return (
//         <ArrowUpOutlined style={{ fontSize: iconSize, color: iconColor }} />
//       );

//     if (order === "descend")
//       return (
//         <ArrowDownOutlined style={{ fontSize: iconSize, color: iconColor }} />
//       );
//   };

//   return {
//     title: (
//       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//         {label}
//         {renderIcon()}
//       </div>
//     ),

//     dataIndex,

//     key: columnKey,

//     sorter: sorter || getDefaultSorter(dataIndex, dataType),

//     sortOrder: order,
//   };
// };

// export default SortableColumn;
